import { Map } from 'immutable';
import {
  FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS,
} from './actions';
import CoveredInClassTemplate from '../model';

export default function CICTemplate(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS:
      return state.set(action.sessionId, onSuccess(state, action));
    default:
      return state;
  }
}

function onSuccess(state, action) {
  const { isDefaultUnchecked, payload } = action;
  return payload.reduce((map, coveredInClass) => {
    const cicCategories = coveredInClass.cicCategories &&
      coveredInClass.cicCategories.map((category) =>
        Object.assign(category, {
          cicCategoryItems: category.cicCategoryItems.map((item) =>
            Object.assign(item, { isChecked: ! isDefaultUnchecked })),
        })
    );
    const template = Object.assign(coveredInClass, { cicCategories });
    return map.set(`${coveredInClass.unitId}-${coveredInClass.lessonNumber}`,
      CoveredInClassTemplate.create(template));
  }, new Map());
}



// WEBPACK FOOTER //
// ./data/CoveredInClass/Template/reducer.js